export const AUDIT_ACTIONS = {
  MEDICATION_ADDED: "medication.added",
  MEDICATION_UPDATED: "medication.updated",
  MEDICATION_DELETED: "medication.deleted",
  EXPIRY_FLAGGED: "expiry.flagged",
  EXPIRY_ACTIONED: "expiry.actioned",
  EXPIRY_DISMISSED: "expiry.dismissed",
  PILL_COUNT_SUBMITTED: "pill_count.submitted",
  REPORT_EXPORTED: "report.exported",
  BULK_IMPORT_COMPLETED: "bulk_import.completed",
};

export async function logAuditEvent({
  action,
  resourceType,
  resourceId,
  metadata = {},
}) {
  try {
    await fetch("/api/audit/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action,
        resourceType,
        resourceId,
        metadata,
        clientTimestamp: new Date().toISOString(),
      }),
    });
  } catch (error) {
    console.warn("[Audit] Failed to log event:", action, error);
  }
}
